var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyN02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707590;}.cls-2{isolation:isolate;}.cls-3{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    className: "cls-1",
    width: 16,
    height: 16,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.57,12H9.85L5.64,5.17h0l0,.38c.06.73.08,1.4.08,2V12H4.43V3.43h1.7l4.2,6.79h0c0-.09,0-.41,0-1s0-1,0-1.32V3.43h1.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyN02);
export default __webpack_public_path__ + "static/media/key_n_02.ff813f21.svg";
export { ForwardRef as ReactComponent };